<template>
    <v-container style="background-color: #fbfbfb">

      <p>Below are my core research papers which I've worked on as a lead author.
        For my complete publication list, please visit my <a href="https://scholar.google.com/citations?user=OEWd96cAAAAJ&hl=en">Google Scholar page</a>.</p>
        <v-row class="py-3">
            <v-col cols="12">
                <v-autocomplete v-for="label in labels"
                                :key="label.alias"
                        v-model="label.selected"
                        :items="label.options"
                        color="primary lighten-1"
                        rounded
                        dense
                                item-text="printed"
                                item-value="key"
                        :label="label.name"
                        multiple
                >
                    <template v-slot:selection="data">
                        <v-chip
                                small
                                v-bind="data.attrs"
                                color="#F2F2F2"
                                :input-value="data.selected"
                                @click="data.select"
                                @click:close="remove(label, data.item)"
                        >
                            {{ data.item.printed }}
                        </v-chip>
                    </template>


                </v-autocomplete>
            </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <template v-for="pubCurYear in pubByYear"
        >
        <v-row :key="pubCurYear.year" style="height: 80px;" align="center">
        <v-col  :align-self="left"
                >
        <span class="small-title" >{{pubCurYear.year}}</span>
        </v-col>
        </v-row>
    <pub v-for="pub in pubCurYear.pubsInYear"
         :key="pub.key"
        :pub="pub"></pub>
    </template>
    </v-container>
</template>
<script>
    import pub from './pub';
    import {bib} from "./pub_data/bib";
    import {labels} from "./pub_data/labels";

    export default {
        name: 'publications',
        components:{
            // eslint-disable-next-line vue/no-unused-components
            pub,
        },
        data: () => ({
            labels
        }),
        computed: {
            curBib() {
                let curBib = [];
                for (const e of bib){
                    let add = true;
                    for (const label of this.labels){
                        if (label.selected.length>0){
                        if (
                            (!(label.alias in e)) ||
                            (label.alias in e &&
                            !label.selected.includes(e[label.alias]))
                            )
                        {
                            add = false;
                        }
                    }
                    }
                    if (add === true){
                        curBib.push(e)
                    }
                }
                return curBib;
            },
            pubByYear() {
                return this.getPubByYear(this.curBib)
            }
        },
        methods:{
            getPubByYear(bibJSON) {
                function GetSortOrder() {
                    return function(a, b) {
                        let year = parseFloat(a.YEAR) - parseFloat(b.YEAR);
                        if (year !== 0) {
                            return year;
                        }
                        let month = parseFloat(a.month) - parseFloat(b.month);
                        if (month !== 0) {
                            return month;
                        }
                        let date = parseFloat(a.date) - parseFloat(b.date);
                        if (date !== 0) {
                            return date;
                        }
                    }
                }
                let yearList = new Set();

                for (let jsonEntry of bibJSON){
                    if (jsonEntry.YEAR.split(", ")[1] !== "submitted")
                    {
                        yearList.add(jsonEntry.YEAR);
                    }
                }

                yearList = Array.from(yearList).sort().reverse();

                let jsonByYear = {}
                for (let year of yearList) {
                    jsonByYear[year] = []
                }
                for (let year in jsonByYear){
                    for (let bibEntry of bibJSON) {
                        if (bibEntry.YEAR === year) {
                            jsonByYear[bibEntry.YEAR].push(bibEntry);
                        }
                    }
                }

                let finalData = [];
                for (let yearName in jsonByYear){
                    let yearEntry = {};
                    yearEntry.year = yearName;
                    yearEntry.pubsInYear = jsonByYear[yearName].sort(GetSortOrder()).reverse();
                    finalData.push(yearEntry);
                }

                finalData = finalData.sort(GetSortOrder()).reverse();

            return finalData;
            },
            remove (label, item) {
                const index = label.selected.indexOf(item.key);
                if (index >= 0) label.selected.splice(index, 1);
            },
        }
    }
</script>
